if (!customElements.get('beam-duo')) {
  customElements.define('beam-duo', class extends HTMLElement {
    connectedCallback() {
      this._abort = new AbortController();
      const signal = this._abort.signal;
      this.querySelectorAll('[data-duo-image]').forEach(button => {
        button.addEventListener('click', () => {
          const image = this.querySelector('.beam-duo__image');
          image.removeAttribute('srcset');
          image.src = button.dataset.duoImage;
          image.alt = button.dataset.duoAlt;
          this.querySelectorAll('[data-duo-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          this.querySelector('[data-duo-count]').textContent = button.dataset.duoIndex.padStart(2, '0');
        }, {signal});
      });
      this.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', () => {
          const target = document.getElementById(link.hash.slice(1));
          if (target && target.tagName === 'DETAILS') target.open = true;
        }, {signal});
      });
      const variant = this.querySelector('[data-duo-variant]');
      if (variant) variant.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.value);
        window.location.assign(url.toString());
      }, {signal});
      const form = this.querySelector('.beam-duo__form');
      const mainButton = this.querySelector('.beam-duo__add');
      const sticky = this.querySelector('.beam-duo__sticky');
      const stickyButton = this.querySelector('.beam-duo__sticky-add');
      stickyButton.addEventListener('click', () => {
        if (!mainButton.disabled && mainButton.getAttribute('aria-disabled') !== 'true') form.requestSubmit(mainButton);
      }, {signal});
      const scheduleSticky = () => {
        if (this._stickyFrame) return;
        this._stickyFrame = requestAnimationFrame(() => {
          this._stickyFrame = null;
          sticky.hidden = mainButton.getBoundingClientRect().bottom > 0;
        });
      };
      window.addEventListener('scroll', scheduleSticky, {passive: true, signal});
      window.addEventListener('resize', scheduleSticky, {passive: true, signal});
      this._observer = new IntersectionObserver(scheduleSticky, {threshold: 0});
      this._observer.observe(mainButton);
      scheduleSticky();
    }
    disconnectedCallback() {
      this._abort?.abort();
      this._observer?.disconnect();
      if (this._stickyFrame) cancelAnimationFrame(this._stickyFrame);
      this._stickyFrame = null;
    }
  });
}
